module.exports = __webpack_public_path__ + "static/img/7.9f163c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/7.jpg
// module id = KJte
// module chunks = 0